import { Box, Typography, Paper, FormHelperText } from "@mui/material";
import { BrandButton } from "components/brand";
import { Upload, Delete } from "@mui/icons-material";
import { ADMIN_TEXTS } from "constants/adminTexts";
import { FILE_INPUT_ACCEPT } from "constants/fileTypes";

const T = ADMIN_TEXTS.about;

export const MediaField = ({
  label,
  file,
  previewUrl,
  isVideo,
  onFileChange,
  onRemove,
  error,
}) => (
  <Box className="media-field">
    <Typography variant="subtitle1" fontWeight={500} gutterBottom>
      {label}
    </Typography>
    {previewUrl ? (
      <Box className="media-preview-wrapper">
        <Paper className="media-preview-paper">
          {isVideo ? (
            <video src={previewUrl} className="media-preview" controls />
          ) : (
            <img src={previewUrl} alt={label} className="media-preview" />
          )}
        </Paper>
        <Box className="media-actions">
          <BrandButton
            variant="secondary"
            component="label"
            startIcon={<Upload />}
            size="small"
          >
            {T.changeMedia}
            <input
              type="file"
              hidden
              accept={FILE_INPUT_ACCEPT.MEDIA}
              onChange={onFileChange}
              onClick={(e) => { e.target.value = null; }}
            />
          </BrandButton>
          {file && (
            <BrandButton
              variant="error"
              startIcon={<Delete />}
              size="small"
              onClick={onRemove}
            >
              {T.removeMedia}
            </BrandButton>
          )}
        </Box>
      </Box>
    ) : (
      <Paper className={`media-empty${error ? " media-empty--error" : ""}`}>
        <Typography variant="body2" color="text.secondary" mb={1}>
          {T.noMedia}
        </Typography>
        <BrandButton
          variant="secondary"
          component="label"
          startIcon={<Upload />}
        >
          {T.uploadMedia}
          <input
            type="file"
            hidden
            accept={FILE_INPUT_ACCEPT.MEDIA}
            onChange={onFileChange}
            onClick={(e) => { e.target.value = null; }}
          />
        </BrandButton>
      </Paper>
    )}
    {error && (
      <FormHelperText error sx={{ mt: 0.5 }}>
        {error}
      </FormHelperText>
    )}
  </Box>
);
